import { useTranslation } from "react-i18next";
export const youtubeChannelLink = 'https://www.youtube.com/channel/UC_8tWfEtsz5JxEUy-yyYkJA'

export const social = [
  { name: "instagram", href: 'https://www.instagram.com/elementalclinic', icon: 'insta' },
  { name: "whatsapp", href: "/wa", sameAs: "https://wa.me/97143830500", icon: "whatsapp" },
  { name: "youtube", href: "https://www.youtube.com/channel/UC5jg28ctQ96Ji3GeEZ4SGWg", icon: "youtube" },
  { name: "facebook", href: 'https://www.facebook.com/profile.php?id=61590759771392', icon: 'fb' },
  { name: "linkedin", href: 'https://www.linkedin.com/company/elemental-dubai/', icon: 'null' },
  { name: "doctify", href: 'https://www.doctify.com/en-ae/practice/elemental-day-surgical-center', icon: 'null' },
  { name: "wiki", href: 'https://www.wikidata.org/wiki/Q141474951', icon: 'null' },
  
]
export const socialContacts = [
  { name: "WhatsApp", href: "/wa", icon: "whatsapp-icon" },
  { name: "Instagram", href: "https://www.instagram.com/elementalclinic", icon: "insta" },
  { name: "Facebook", href: "https://www.facebook.com/profile.php?id=61590759771392", icon: "fb" },
]

export const phones = [{
  title: '+971 4 383 0500',
  href: 'tel:+97143830500',
  icon: "phone-icon",
}]

export const email = {
  title: 'appointment@elemental.ae',
  href: 'mailto:appointment@elemental.ae',
  icon: "email-icon",
}

export const emailFooter = {
  title: 'info@elemental.ae',
  href: 'mailto:info@elemental.ae',
  icon: "email-icon",
}

export const legalLinks = {
  newsletter: '/mail.pdf',
  publicOffer: '/oferta.pdf',
  personalDataInstruction: '/personal-data-instruction.pdf',
  personalDataProcessingPolicy: '/Patient Rights and Responsibilities.pdf',
}

const PHONE_ERROR_MESSAGE = 'Please check the phone number, e.g. 050 123 4567 or +971 50 123 4567'
export const PHONE_CHECK_MESSAGE = 'Please check the phone number, e.g. 050 123 4567 or +971 50 123 4567'
export const SERVER_ERROR_MESSAGE = 'Ошибка сервера, попробуйте позже'

export const formErrors = {
  phone: {
    required: PHONE_ERROR_MESSAGE,
    pattern: PHONE_ERROR_MESSAGE,
    validate: PHONE_ERROR_MESSAGE,
  },
  email: {
    validate: 'The data entered is incorrect',
  },
  message: {
    required: 'Please add a message',
  },
  review: {
    required: 'Don’t forget to write a review',
  },
  default: {
    required: 'Required field',
  },
}

export const regExp = {
  email:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  date: /^(((0[1-9]|[12]\d|3[01])\-(0[13578]|1[02])\-((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\-(0[13456789]|1[012])\-((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\-02\-((19|[2-9]\d)\d{2}))|(29\-02\-((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/,
}

const { normalizePhone, normalizeEmail } = require('./normalizePhone')

export { normalizePhone, normalizeEmail }
